import { Country } from './types';

export const findCountryById = (
    id: number,
    countries: Country[]
): Country | undefined => countries.find((country) => country.id === id);

export const getCountryName = (id: number, countries: Country[]): string => {
    return findCountryById(id, countries)?.name || '';
};

export const getCountryPhoneCode = (
    id: number,
    countries: Country[]
): number => {
    const foundCountry = findCountryById(id, countries);
    return foundCountry ? +foundCountry.phoneCode : -1;
};
